<template>
	<v-tooltip
		:z-index="zIndex"
		v-bind="tooltipBind"
		:open-delay="OPEN_HOVER_DELAY_TIME"
		:close-delay="CLOSE_HOVER_DELAY_TIME"
		:content-class="noArrow ? '' : position"
	>
		<template v-slot:activator="{ on, attrs }">
			<div v-on="on" v-bind="attrs" class="flex-centerize">
				<slot />
			</div>
		</template>
		<slot name="tooltip-content">
			<span v-html="sanitizedText" />
		</slot>
	</v-tooltip>
</template>

<script>
import { sanitizeHtml } from '@/utils/helpers';
const OPEN_HOVER_DELAY_TIME = 300; // daley until open of tooltip on hover
const CLOSE_HOVER_DELAY_TIME = 0; // daley until close of tooltip on hover

export default {
	name: 'AppTooltip',
	props: {
		text: { type: String },
		noArrow: { type: Boolean },
		position: { type: String, default: 'top' },
		zIndex: { type: Number, default: 999999999 },
	},
	data() {
		return {
			OPEN_HOVER_DELAY_TIME,
			CLOSE_HOVER_DELAY_TIME,
		};
	},
	computed: {
		tooltipBind() {
			return { ...this.$attrs, [this.position]: true };
		},
		sanitizedText() {
			return sanitizeHtml(this.text);
		},
	},
};
</script>

<style scoped lang="scss">
.v-tooltip__content {
	opacity: 1 !important;
	padding: 6px 5px !important;
	color: var(--bg-color) !important;
	font: normal normal normal 12px proxima-nova !important;
	background-color: var(--tooltop-black-background) !important;
	&.bottom:after {
		left: 0;
		right: 0;
		margin-left: auto;
		margin-right: auto;
		width: 0 !important;
		top: -5px !important;
		height: 0 !important;
		content: '' !important;
		position: absolute !important;
		transform: rotate(180deg) !important;
		border-left: 5px solid transparent !important;
		border-right: 5px solid transparent !important;
		border-top: 5px solid var(--tooltop-black-background) !important;
	}
	&.top:after {
		left: 0;
		right: 0;
		margin-left: auto;
		margin-right: auto;
		width: 0 !important;
		height: 0 !important;
		content: '' !important;
		bottom: -5px !important;
		position: absolute !important;
		border-left: 5px solid transparent !important;
		border-right: 5px solid transparent !important;
		border-top: 5px solid var(--tooltop-black-background) !important;
	}
	&.right:after {
		width: 0 !important;
		height: 0 !important;
		content: '' !important;
		left: -7px !important;
		position: absolute !important;
		top: calc(50% - 2.5px) !important;
		transform: rotate(90deg) !important;
		border-left: 5px solid transparent !important;
		border-right: 5px solid transparent !important;
		border-top: 5px solid var(--tooltop-black-background) !important;
	}
	&.left:after {
		width: 0 !important;
		height: 0 !important;
		content: '' !important;
		right: -7px !important;
		position: absolute !important;
		top: calc(50% - 2.5px) !important;
		transform: rotate(-90deg) !important;
		border-left: 5px solid transparent !important;
		border-right: 5px solid transparent !important;
		border-top: 5px solid var(--tooltop-black-background) !important;
	}
}
</style>
